import {GetSeferData}   from "SeferPetach/GetData";

export async function getOrdersList(obj) {
    var payload = await GetSeferData("of1", obj);
    return (payload);
}
export async function getOrderByID(order_id){
    var payload = await GetSeferData("of13", {'ORDER_ID': order_id});
    return (payload);
}